import { useMemo } from 'react';
import { useTranslation } from '@packlink/translation-provider';

const useSelectAutocompleteMessages = (selector, labelTranslationKey) => {
  const {
    t
  } = useTranslation();
  const fieldTranslationKey = selector === 'postalCode' ? t(labelTranslationKey || 'address-selectors.postal-code.label') : t(labelTranslationKey || 'address-selectors.postal-zone.label');
  const selectAutocompleteMessages = useMemo(() => ({
    start: t('address-selectors.select.start-typing', {
      field: fieldTranslationKey
    }),
    loading: t('address-selectors.select.loading'),
    noResults: t('address-selectors.select.no-results')
  }), [fieldTranslationKey, t]);
  return selectAutocompleteMessages;
};

export { useSelectAutocompleteMessages };
//# sourceMappingURL=useSelectAutocompleteMessages.js.map
